module.exports = __webpack_public_path__ + "img/bn19.a64ea0aa.png";